export default "__VITE_ASSET__C853XHwy__"